import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaCalendarCheck, FaEnvelopeOpenText } from "react-icons/fa";
import heroBanner from "../../assets/hero-banner.png";
import "./LandingPage.css";

const Home = () => {
    // Smooth scroll handler
    const scrollToContact = () => {
        const contactSection = document.getElementById("contact-section");
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="hero-section d-flex align-items-center">
            <Container>
                <Row className="align-items-center gy-4">
                    {/* Text Content */}
                    <Col
                        md={6}
                        className="text-center text-md-start slide-left order-1"
                    >
                        
                        <h1 className="display-4 hero-title" data-aos="fade-right">
                            <span className="hero-title-line">Welcome to</span>
                            <span className="hero-title-line">MediConnect Hospital</span>
                        </h1>

                        <p className="lead text-dark mb-4" data-aos="fade-right" data-aos-delay="100">
                            Providing world-class medical care and healthcare solutions, 24/7.
                            Our mission is your well-being.
                        </p>

                        <div className="lead" data-aos="fade-right" data-aos-delay="200">
                            🕒 Open 24/7 for emergencies.
                            <br />
                            🏥 Regular outpatient timings:&nbsp;
                            <strong className="timing-line d-block d-md-inline highlight-green">
                                Mon–Sat, 8:00 AM – 8:00 PM
                            </strong>
                            <span className="d-block d-md-inline highlight-green"> &nbsp;|&nbsp; </span>
                            <div className="mt-2 mt-md-0 d-inline-block">
                                <strong className="timing-line d-block d-md-inline highlight-green">
                                    Sun, 9:00 AM – 7:00 PM
                                </strong>
                            </div>
                        </div>
                    </Col>

                    {/* Image */}
                    <Col md={6} className="text-center order-2 mt-5 mt-md-0">
                        <div className="position-relative d-inline-block">
                            <img
                                src={heroBanner}
                                alt="Hospital Banner"
                                className="img-fluid hero-img"
                                data-aos="zoom-in"
                                data-aos-delay="300"
                            />
                            
                            {/* Floating Badges */}
                            <div className="floating-badge badge-1" data-aos="fade-left" data-aos-delay="500">
                                <span className="fs-3">🏆</span>
                                <div className="text-start">
                                    <strong className="d-block text-dark lh-1 mb-1">Top Doctors</strong>
                                    <small className="text-muted">Award Winning</small>
                                </div>
                            </div>

                            <div className="floating-badge badge-2" data-aos="fade-right" data-aos-delay="600">
                                <span className="fs-3">🚑</span>
                                <div className="text-start">
                                    <strong className="d-block text-dark lh-1 mb-1">24/7 Service</strong>
                                    <small className="text-muted">Emergency Care</small>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Appointment Section */}
                <Row className="text-center appointment-section py-5 mt-5">
                    <Col>
                        <h2 className="fw-bold text-primary mb-3">
                            Hassle-free Hospital Appointment Booking
                        </h2>
                        <p className="lead text-muted mb-4">
                            Book appointments online from the comfort of your home, at your
                            preferred time with top doctors — no long queues, no unnecessary waiting. Get
                            instant confirmation and manage your visits easily.
                        </p>

                        {/* Buttons */}
                        <div className="d-flex justify-content-center flex-wrap gap-3 mt-4" data-aos="fade-up" data-aos-delay="400">
                            <Link to="/signup" style={{ textDecoration: "none" }}>
                                <button className="btn btn-success action-btn">
                                    <FaCalendarCheck className="me-2" />
                                    Book an Appointment
                                </button>
                            </Link>

                            <button
                                className="btn btn-outline-primary action-btn"
                                onClick={scrollToContact}
                            >
                                <FaEnvelopeOpenText className="me-2" />
                                Contact Us
                            </button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Home;
